import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function CssBaseline(theme: Theme) {
  const scrollbarTrack = theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.grey[100];
  const scrollbarThumb = theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[400];

  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
          scrollbarColor: `${scrollbarThumb} ${scrollbarTrack}`,
          scrollbarWidth: 'thin',
        },
        '*::-webkit-scrollbar': {
          width: 10,
          height: 10,
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: scrollbarTrack,
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: scrollbarThumb,
          borderRadius: 999,
          border: `2px solid ${scrollbarTrack}`,
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
          backgroundColor: theme.palette.background.default,
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.default,
          fontFamily: theme.typography.fontFamily,
          transition: theme.transitions.create(['background-color', 'color'], {
            duration: theme.transitions.duration.shortest,
          }),
        },
        '#root, #__next': {
          width: '100%',
          height: '100%',
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.default,
        },
        a: {
          color: 'inherit',
        },
        'button, input, textarea, select': {
          font: 'inherit',
        },
        '::selection': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom',
        },
      },
    },
  };
}
